<div class="l-wrapper">
  <app-header></app-header>
  <div class="l-faq">
    <app-question-view></app-question-view>
  </div>
  <app-footer></app-footer>
</div>
